module.exports = {
          srcSet: __webpack_public_path__ + "public/images/323af360fce797fb1e903a0c26f65c9c-1905.jpg"+" 1905w",
          images:[ {path: __webpack_public_path__ + "public/images/323af360fce797fb1e903a0c26f65c9c-1905.jpg",width: 1905,height: 682}],
          src: __webpack_public_path__ + "public/images/323af360fce797fb1e903a0c26f65c9c-1905.jpg",
          toString:function(){return __webpack_public_path__ + "public/images/323af360fce797fb1e903a0c26f65c9c-1905.jpg"},
          
          width: 1905,
          height: 682
        }